import $ from 'jquery';

if( $( '.services-list' ).length ) {
  setTimeout( () => {
    $( '.services-list' ).slick( 'slickGoTo', $( '.service-title' ).length - 1 )
  }, 2500 )
}